import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=26f7271c&scoped=true&"
import script from "./Analytics.vue?vue&type=script&lang=ts&"
export * from "./Analytics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7271c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f7271c')) {
      api.createRecord('26f7271c', component.options)
    } else {
      api.reload('26f7271c', component.options)
    }
    module.hot.accept("./Analytics.vue?vue&type=template&id=26f7271c&scoped=true&", function () {
      api.rerender('26f7271c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/analytics/Analytics.vue"
export default component.exports